if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      loadFullResolutionImage(mediaElement) {
        if (!mediaElement) return;

        const image = mediaElement.tagName === 'IMG' ? mediaElement : mediaElement.querySelector('img');

        if (!image?.srcset) return;

        const largestSource = image.srcset
          .split(',')
          .map((entry) => entry.trim().split(/\s+/))
          .map(([url, descriptor]) => ({
            url,
            width: parseInt(descriptor, 10) || 0,
          }))
          .filter((entry) => entry.url)
          .sort((first, second) => second.width - first.width)[0];

        if (!largestSource?.url) return;

        image.src = largestSource.url;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.loadFullResolutionImage(activeMedia);
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.offsetWidth) {
          container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
